import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  shared: {
    VERCEL_URL: z
      .string()
      .optional()
      .transform((v) => (v ? `https://${v}` : undefined)),
    PORT: z.coerce.number().default(3000),
  },
  client: {
    NEXT_PUBLIC_CONVEX_URL: z.string(),
    NEXT_PUBLIC_CONVEX_SITE_URL: z
      .string()
      .refine(
        (url) =>
          url.endsWith(".convex.site") ||
          url.includes("hausverwalter.ai") ||
          // Agent server previews: https://<slug>.dev.hausverwalterai.de/_convex_site
          /^https:\/\/[a-z0-9-]+\.dev\.hausverwalterai\.de\//.test(url),
        {
          message:
            "NEXT_PUBLIC_CONVEX_SITE_URL muss auf .convex.site enden, eine hausverwalter.ai-Subdomain oder eine Agent-Server-Vorschau sein",
        },
      ),
    NEXT_PUBLIC_SITE_URL: z.string().url(),
    NEXT_PUBLIC_OPENPANEL_CLIENT_ID: z.optional(z.string()),
  },
  runtimeEnv: {
    NEXT_PUBLIC_CONVEX_URL: process.env.NEXT_PUBLIC_CONVEX_URL,
    NEXT_PUBLIC_CONVEX_SITE_URL: process.env.NEXT_PUBLIC_CONVEX_SITE_URL,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_OPENPANEL_CLIENT_ID:
      process.env.NEXT_PUBLIC_OPENPANEL_CLIENT_ID,
    PORT: process.env.PORT,
    VERCEL_URL: process.env.VERCEL_URL,
  },
  skipValidation: !!process.env.CI || !!process.env.SKIP_ENV_VALIDATION,
});
